/*
 * Records added by name alone from another form — a category or unit typed
 * into the item form, a farm typed into the store form — are marked for
 * review until someone opens them where they are managed and saves them.
 * These are the marks that say so, shared by every screen that has them.
 */

/**
 * A warning pill for a row still to be reviewed. Given `onReview` (the user may
 * edit it), the pill is a button that opens the review, as the banner's does.
 */
export function ReviewPill({ label, onReview }: { label: string; onReview?: (() => void) | undefined }) {
  if (!onReview) return <span className="pill pill--warn">{label}</span>;
  return (
    <button
      type="button"
      className="pill pill--warn pill--action"
      title="Review"
      onClick={(e) => {
        // The row would otherwise take the click as a select.
        e.stopPropagation();
        onReview();
      }}
    >
      {label}
    </button>
  );
}

/** What waits for review on this screen, with a way to start — when the user
 *  may edit — and the same words at the top of the form being reviewed. */
export function ReviewBanner({ message, onReview }: { message: string; onReview?: (() => void) | undefined }) {
  return (
    <div className="reviewbanner" role="status">
      <span className="reviewbanner__text">
        <span aria-hidden="true">⚠ </span>
        {message}
      </span>
      {onReview && (
        <button type="button" className="btn btn--sm" onClick={onReview}>
          Review
        </button>
      )}
    </div>
  );
}
